import React from 'react';

import useBorder from '#hooks/useBorder';
import { Text } from '@/components/Text';
import ExpertiseCardContent from './ExpertiseCardContent';
import type { InteractiveExpertiseCard } from '../InteractiveExpertiseGraphic';
import CardBanner from './CardBanner';

type ExpertiseCardProps = {
  card: InteractiveExpertiseCard,
  bannerColor: string,
};

const ExpertiseCard = ({
  card,
  bannerColor,
}: ExpertiseCardProps) => {
  const { border, content, title } = card || {};
  const borderSettings = useBorder(border);

  return (
    <div
      style={borderSettings}
      className="relative bg-[rgba(237,242,246,0.8)] bg-cover z-[1] px-[2.5em] py-[1.2em] mt-[1.8em]"
    >
      <div className="pt-[5px]">
        <div className="w-full flex items-center mb-[12px] relative">
          <CardBanner fill={bannerColor} className="ml-[-41px] w-full" />
          <Text variant="h3" className="absolute text-white m-0 bg-transparent text-[1.1rem] !important md:text-[1.3rem] !important">
            {title}
          </Text>
        </div>
        <div className="grid grid-cols-1 relative mb-[1em]">
          {content && content.map((item) => (
            <div key={item.id} className="w-full">
              <ExpertiseCardContent content={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExpertiseCard;
